/**
 * White-label display names for CDN provider backends.
 *
 * The BE returns normalized provider codenames (e.g. "eagle") plus legacy
 * scope identifiers (e.g. "External.SwiftFederation") for grouping. The scope
 * strings embed upstream vendor names that must never surface in the UI, so
 * every user-visible provider label goes through this map instead. Mirrors
 * `providers.display_name` in the @mgmt service catalog.
 */
const PROVIDER_LABEL: Record<string, string> = {
  raven: 'Raven CDN',
  eagle: 'Eagle CDN',
  hawk: 'Hawk CDN',
  hummingbird: 'Hummingbird CDN',
  giraffe: 'Giraffe Cloud',
  owl: 'Multi-CDN',
};

/** Friendly label for a normalized provider codename — never echoes a scope. */
export function cdnProviderLabel(providerName?: string): string {
  if (!providerName) return 'CDN provider';
  const key = providerName.toLowerCase();
  const label = PROVIDER_LABEL[key];
  if (label) return label;
  // Unknown codename: capitalize it rather than fall back to a scope string.
  return key.charAt(0).toUpperCase() + key.slice(1);
}
